import * as React from 'react';
import './TableHeader.scss';

export interface IColumn {
  id: string;
  name: string;
  spaces: number;
  isSortable: boolean;
}

interface ITableHeaderProps {
  headers: IColumn[];
  handleSortBy: (option: string) => void;
  sortBy: string[];
}

const TableHeader: React.FC<ITableHeaderProps> = props => {
  const { headers, handleSortBy, sortBy } = props;

  return (
    <div className="rp-table-header">
      <div className="container-fluid">
        <div className="row">
          {headers.map(header => (
            <div
              key={header.id}
              className={`col-${header.spaces} rp-table-header-col ${header.id}`}
            >
              <div className="rp-table-header-wrapper-column">
                <p className="rp-table-header-title">{header.name}</p>
                {header.isSortable && (
                  <div className="rp-table-header-wrapper-arrows">
                    <i
                      onClick={() => handleSortBy(`${header.id},asc`)}
                      className={`rpds-arrow-drop-up rp-table-header-arrow 
                            ${sortBy.indexOf(`${header.id},asc`) !== -1 &&
                              'selected'}`}
                    />
                    <i
                      onClick={() => handleSortBy(`${header.id},desc`)}
                      className={`rpds-arrow-drop-down rp-table-header-arrow
                            ${sortBy.indexOf(`${header.id},desc`) !== -1 &&
                              'selected'}`}
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TableHeader;
